import React, { useState, useRef } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { navigate } from 'gatsby';

import Icon from '../Icon';

import { color } from '../../atoms/colors';
import {
  LayoutWrapper,
  Container,
  Label,
  Input,
  Button,
} from './styles/ExternalSearch.styled';

const ExternalSearchBar = ({ placeholder, fullWidth, type }) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const [value, setValue] = useState(null);
  const [inputFocused, setInputFocused] = useState(false);
  const typeQuery = type ? `&type=${type}` : '';

  const handleSearch = () => {
    navigate(`/resources/search-results/?query=${value}${typeQuery}`);
  };

  const handleKeyPress = event => {
    if (event.keyCode === 13 || event.which === 13) {
      handleSearch();
    }
  };

  return (
    <LayoutWrapper fullWidth={fullWidth}>
      <Container id="defaultSearchBar" isFocused={inputFocused}>
        <Label htmlFor="search" />
        <Icon
          id="search-lg"
          strokeColor={color.darkBlue[400]}
          width="20px"
          height="20px"
        />
        <Input
          ref={inputRef}
          name="search"
          type="text"
          placeholder={placeholder || t('Search')}
          value={value}
          autoComplete="off"
          onChange={e => setValue(e.target.value)}
          onFocus={() => {
            setInputFocused(true);
          }}
          onKeyPress={e => handleKeyPress(e)}
        />
      </Container>
      <Button type="button" onClick={() => handleSearch()}>
        <Icon
          id="search-lg"
          strokeColor={color.common.white}
          width="20px"
          height="20px"
        />
      </Button>
    </LayoutWrapper>
  );
};

export default ExternalSearchBar;
